import { ImportProject, Project } from '../interfaces/project';
import { Capacitor } from '@capacitor/core'
import { v4 as uuidv4 } from 'uuid';
import { MAX_CHARACTERS, MAX_CHARACTERS_IN_DEVICE } from '../constants/global';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export class SuppliesUtils {

    /**
     * Retorna el nombre del dispositivo donde esta corriendo la aplicación
     * @returns {string}
     */
    static get RunningDevice(): string {
        return Capacitor.getPlatform();
    }

    /**
     * Genera un nuevo UUID
     * @returns {string}
     */
    static get generateUUID(): string {
        return uuidv4();
    }

    /**
     * Agrega imagen de fondo a las pantallas
     * @returns {void}
     */
    static addImageBackground(class_type: string = 'transfer-page'): void {
        const Page: Element = document.getElementsByClassName('full-page')[0];
        const ImageContainer: HTMLDivElement = document.createElement('div');
        ImageContainer.classList.add('full-page-background');
        ImageContainer.style.backgroundImage = `url(assets/img/fondo2.jpg)`;
        Page.appendChild(ImageContainer);
        Page.classList.add(class_type);
    }

    /**
     * Permite la exportación de un archivo
     * @param {any} project_file
     * @returns {Promise<boolean>}
     */
    static exportFile({ content, file_name }: any): Promise<boolean> {
        return new Promise((resolve) => {
            const File: Blob = new Blob([content]);
            /**
             *! La función msSaveOrOpenBlob actualmente se encuenta obsoleta,
             *! se usa al no encontrar una alternativa a la misma, pero debe de cambiarse
             *! en un futuro.
             */
            if ((window.navigator as any).msSaveOrOpenBlob) {
                (window.navigator as any).msSaveOrOpenBlob(File, file_name);
            } else {
                const Element: HTMLAnchorElement = document.createElement("a");
                const Url: string = URL.createObjectURL(File);
                Element.href = Url;
                Element.download = file_name;
                document.body.appendChild(Element);
                Element.click();
                document.body.removeChild(Element);
                window.URL.revokeObjectURL(Url);
                resolve(true);
            }
        });
    }

    /**
     * Importar archivos de texto plano para realizar la transferencia
     * @param {any} file 
     * @param {string} extendFile 
     * @return {Promise<ImportProject>}
     */
    static importFile(file: any, extendFile: string = '.mow'): Promise<ImportProject> {
        const Reader: FileReader = new FileReader();
        return new Promise<ImportProject>((resolve) => {
            const NameFile: Array<string> = file.name.split('.');
            if (NameFile.pop() === extendFile.split('.')[1]) {
                Reader.onload = () => {
                    resolve({ status: true, content: Reader.result, message: '', name: NameFile[0] })
                }
                Reader.readAsText(file);
            } else resolve({ status: false, message: 'Project_admin.ERRORS.EXTEND_FILE' })
        });
    }

    /**
     * Genera un nuevo nombre para el proyecto duplicado
     * @param {Array<Project>} projects - Lista de proyectos
     * @param {string} name - Nombre del proyecto actual
     * @returns {string}
     */
    static generateNewName(projects: Array<Project>, name: string): string {

        const existingNames = new Set(projects.map(project => project.name));

        if (!existingNames.has(name)) {
            return name.length > MAX_CHARACTERS ? name.slice(0, MAX_CHARACTERS) : name;
        }

        let id: number = 1;

        while (true) {
            const suffix = `(${id})`;
            const maxBaseLength = MAX_CHARACTERS - suffix.length;
            const baseName = name.length > maxBaseLength ? name.slice(0, maxBaseLength) : name;
            const newName = `${baseName}${suffix}`;

            if (!existingNames.has(newName)) return newName;
            id++;
        }

        //!let id: number = 1;
        //!let new_name: string = `${name}`;
        //!while (true) {
        //!    const isExist: boolean = projects.some(project => project.name === new_name);
        //!    if (isExist) {
        //!        new_name = `${name}(${id})`;
        //!        id++;
        //!    } else break;
        //!}
        //!return new_name;
    }

    /**
     * Retorna el texto corregido sí tiene menos de 16 caracteres
     * @param {string} text - Texto a corregir
     * @returns {string} Texto corregido.
     */
    static getCorrectText(text: string): string {
        const TextSize: number = text.length;
        if (TextSize < MAX_CHARACTERS_IN_DEVICE) {
            const MissingChars: number = (MAX_CHARACTERS_IN_DEVICE - TextSize);
            const LeftPart: number = Math.round(MissingChars / 2);
            const LeftEnd: string = text.padEnd((TextSize + LeftPart), ' ');
            return (LeftEnd.padStart(MAX_CHARACTERS_IN_DEVICE, ' '));
        } return text;
    }
}

/**
 * Carga el contenido configurado por cada idioma ('es', 'en', 'por')
 * @param { HttpClient } http 
 * @returns { TranslateHttpLoader }
 */
export function LoadTranslateJSON(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

/*     static verifyCommandPetition(args: {
        command: string;
        data: string[];
        lengthCommand: number;
        lang: any;
    }) {
        let lResponse: any;
        lResponse = args.data;
        let data: string;
        for (let k = 0; k < lResponse.length; k++) {
            data = lResponse[k];
            if (data.length === args.lengthCommand) {
                const tmpResponse = {
                    letter: data.substr(0, 1),
                    lengthResponse: data.substr(1, 3),
                    command: data.substr(4, 2),
                    validate: data.substr(6, 1),
                    checkSum: data.substr(7, 2)
                };
                const tmpCommand = `${tmpResponse.letter}${tmpResponse.lengthResponse}${tmpResponse.command}${tmpResponse.validate}`;
                const chckSum = SuppliesUtils.checkSum(tmpCommand);
                if (chckSum !== tmpResponse.checkSum) {
                    if (k === lResponse.length - 1) {
                        return {
                            ok: false,
                            retry: false
                        }
                    }
                } else {
                    if (tmpResponse.command === args.command ) {
                        // tslint:disable-next-line:max-line-length
                        if (tmpResponse.validate === 'D' || tmpResponse.validate === 'L' || tmpResponse.validate === 'U' || tmpResponse.validate === 'A') {
                            switch (tmpResponse.validate) {
                                case 'D': {
                                    return {
                                        ok: true,
                                        retry: false,
                                        denied: true,
                                        confirm: false,
                                        petition: false,
                                        continue: false,
                                    }
                                };
                                case 'A': {
                                    return {
                                        ok: true,
                                        retry: false,
                                        denied: false,
                                        confirm: false,
                                        petition: true,
                                        continue: false,
                                    }
                                }
                                case 'U': {
                                    return {
                                        ok: true,
                                        retry: false,
                                        denied: false,
                                        confirm: false,
                                        petition: false,
                                        continue: true,
                                    }
                                }
                                case 'L': {
                                    return {
                                        ok: true,
                                        retry: false,
                                        denied: false,
                                        confirm: true,
                                        petition: false,
                                        continue: false,
                                    }
                                }
                            }
                        } else {
                            if (tmpResponse.validate === 'B' && args.command === 'FK') {
                                k = lResponse.length;
                                return {
                                    ok: true,
                                    retry: false,
                                    denied: false,
                                    confirm: false,
                                    petition: true,
                                    continue: false,
                                }
                            } else {
                                if (k === lResponse.length - 1) {
                                    return {
                                        ok: false,
                                        retry: true
                                    }
                                }
                            }
                        }
                    } else {
                        if (k === lResponse.length - 1) {
                            return {
                                ok: false,
                                retry: false
                            }
                        }
                    }
                }
            }
        }
    } */



/* ValidarRespuesta(vector:any){
   let Contiene_A:boolean;
   if(vector.join('').length>4){
     console.log("Respuesta: ",vector.join(''));
     let RespDevice=vector.join('');

     //Se encuentra la longitud con los caracteres del 1 al 3 y se pasa a Decimal.
     let recortado=RespDevice.slice(1,4);
     recortado=parseInt(recortado).toString(10);
   
     if(RespDevice.length===parseInt(recortado)){
       let checksumresp=RespDevice.slice(parseInt(recortado)-2,parseInt(recortado));
       console.log("Checksum respuesta device",checksumresp);

     //Se calcula el checksum del comando recibido y se compara. 
       let checksumCalculado=RespDevice.slice(0,(parseInt(recortado)-2));
       checksumCalculado=this.checkSum(checksumCalculado);
       console.log("Checksum calculado",checksumCalculado);

     //Se busca que contenga una A en sus caracteres.
       if(checksumCalculado===checksumresp){
        Contiene_A=RespDevice.includes("A");

        //Si tiene una A en sus caracteres muestra un "OK"
        if(Contiene_A===true){
         console.log("ok");
         this.onStartTimeSendFile();
         return this.ok=true;
       }
       else{
         console.log("Error");
       }
       }
       else{
         console.log("Error Checksum");
         return this.ok=false;}
     }
     else{
       console.log(" Error Longitud",RespDevice);
       return this.ok=false;}
   }
}  */


